export default "__VITE_ASSET__d78fe9ab__"